/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} EditInputs */

const en_edit = /** @type {(inputs: EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const fr_edit = /** @type {(inputs: EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Édition`)
};

const de_edit = /** @type {(inputs: EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

const it_edit = /** @type {(inputs: EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificare`)
};

const ru_edit = /** @type {(inputs: EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать`)
};

const es_edit = /** @type {(inputs: EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const zh_cn2_edit = /** @type {(inputs: EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑`)
};

const ja_edit = /** @type {(inputs: EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集`)
};

const hi_edit = /** @type {(inputs: EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादन करना`)
};

const pt_pt2_edit = /** @type {(inputs: EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {EditInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit = /** @type {((inputs?: EditInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EditInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit(inputs)
	if (locale === "de") return de_edit(inputs)
	if (locale === "it") return it_edit(inputs)
	if (locale === "ru") return ru_edit(inputs)
	if (locale === "es") return es_edit(inputs)
	if (locale === "zh-CN") return zh_cn2_edit(inputs)
	if (locale === "ja") return ja_edit(inputs)
	if (locale === "hi") return hi_edit(inputs)
	if (locale === "pt-PT") return pt_pt2_edit(inputs)
	return en_edit(inputs)
});